<template>
    <FormControl
        label="Frequency"
        :error="
            errors.getValidationError(
                RequestBodyKeyEnum.App_UpdateService_RecurrenceSettings_FrequencyType,
            )
        "
    >
        <SelectInput
            :name="
                RequestBodyKeyEnum.App_UpdateService_RecurrenceSettings_FrequencyType
            "
            v-model="localService.recurrenceSettings.frequencyType"
            :disabled="isDisabled"
        >
            <option
                v-for="recurrenceFrequencyType in RecurrenceFrequencyTypeEnumList"
                :value="recurrenceFrequencyType.key"
            >
                {{ recurrenceFrequencyType.label }}
            </option>
        </SelectInput>
    </FormControl>

    <template
        v-if="
            localService.recurrenceSettings.frequencyType ===
            RecurrenceFrequencyTypeEnum.Single
        "
    >
        <input
            type="hidden"
            :name="
                RequestBodyKeyEnum.App_UpdateService_RecurrenceSettings_MaximumNumberOfRecurringMeetings
            "
            value="1"
        />
        <input
            type="hidden"
            :name="
                RequestBodyKeyEnum.App_UpdateService_RecurrenceSettings_AllowCustomNumberOfRecurringMeetings
            "
            value="0"
        />
    </template>
    <template v-else>
        <FormControl label="Maximum number of meetings">
            <TextInput
                type="number"
                inputmode="numeric"
                step="1"
                min="2"
                :name="
                    RequestBodyKeyEnum.App_UpdateService_RecurrenceSettings_MaximumNumberOfRecurringMeetings
                "
                :value="
                    localService.recurrenceSettings
                        .maximumNumberOfRecurringMeetings
                "
                :disabled="isDisabled"
            />
        </FormControl>
        <FormControl label="Customer can chose the number of meetings">
            <ToggleInput
                label="Allow customer to chose a smaller number of meetings"
                :name="
                    RequestBodyKeyEnum.App_UpdateService_RecurrenceSettings_AllowCustomNumberOfRecurringMeetings
                "
                :checked="
                    localService.recurrenceSettings
                        .allowCustomNumberOfRecurringMeetings
                "
                :disabled="isDisabled"
            />
        </FormControl>
        <FormControl label="Skip dates with no availability">
            <ToggleInput
                label="Skip dates with no availability specified when generating the sequence of dates"
                :name="
                    RequestBodyKeyEnum.App_UpdateService_RecurrenceSettings_SkipDatesWithNoAvailability
                "
                :checked="
                    localService.recurrenceSettings.skipDatesWithNoAvailability
                "
                :disabled="isDisabled"
            />
        </FormControl>
    </template>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import Service from '@/App/Service/Entity/Service'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import SelectInput from '@/Shared/Component/Forms/SelectInput.vue'
    import {
        RecurrenceFrequencyTypeEnum,
        RecurrenceFrequencyTypeEnumList,
    } from '@/Shared/AutoGenerated/Main'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import ToggleInput from '@/Shared/Component/Forms/ToggleInput.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        service: {
            type: Object as PropType<Service>,
            required: true,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: true,
        },
    })

    const localService = ref<Service>(props.service)
</script>
